import { useGetProduct } from "queries/product-queries";
import { SSR_CONFIGURATION_ERROR } from "utils/error-utils";
import { CANVAS_FALLBACK_CONTENT } from "utils/fallback-content";
import { useInterpolate } from "utils/prismic-utils";

import { PageLayout } from "../pages/Pages";

import styles from "./LayoutSelector.module.scss";

type LayoutSelectorProps = {
  layout: PageLayout;
  setLayout: (layout: PageLayout) => void;
};

export default function LayoutSelector({
  layout,
  setLayout,
}: LayoutSelectorProps) {
  const { data: product } = useGetProduct();

  const interpolate = useInterpolate();

  if (!product) {
    throw SSR_CONFIGURATION_ERROR;
  }

  return (
    <div className={styles.layoutSelector}>
      <button
        onClick={() => setLayout("one-page")}
        className={[
          styles.layoutButton,
          layout === "one-page" && styles.active,
        ].join(" ")}
      >
        <OnePageIcon />
        <span>
          {interpolate(
            product.content.canvas.one_page_button_label ??
              CANVAS_FALLBACK_CONTENT.one_page_button_label
          )}
        </span>
      </button>

      <button
        onClick={() => setLayout("two-page")}
        className={[
          styles.layoutButton,
          layout === "two-page" && styles.active,
        ].join(" ")}
      >
        <TwoPageIcon />
        <span>
          {interpolate(
            product.content.canvas.two_page_button_label ??
              CANVAS_FALLBACK_CONTENT.two_page_button_label
          )}
        </span>
      </button>
    </div>
  );
}

function OnePageIcon() {
  return (
    <svg
      className={styles.layoutIcon}
      fill="none"
      viewBox="0 0 27 27"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect height="25" rx="1" strokeWidth="2" width="25" x="1" y="1" />
    </svg>
  );
}

function TwoPageIcon() {
  return (
    <svg
      className={styles.layoutIcon}
      fill="none"
      viewBox="0 0 52 27"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 2a1 1 0 011-1h24v25H2a1 1 0 01-1-1V2zM26 1h24a1 1 0 011 1v23a1 1 0 01-1 1H26V1z"
        strokeWidth="2"
      />
    </svg>
  );
}
